import React, { useEffect } from 'react'
import styles from './Highlights.module.scss'
import ReactGA from 'react-ga4';

const Highlights = () => {
    useEffect(() => {
        try {
            ReactGA.send({ hitType: 'pageview', page: '/game-feedback/highlights', title: 'Highlights' });
        } catch {}
    }, []);

    return (
        <div className={styles.Highlights}>
            <div className={styles.heading}>
                <h5>Video</h5>
            </div>

            <hr />


        </div>
    )
}

export default Highlights